import type { SiteContent } from '../schema';

export const siteContent = {
  siteUrl: 'https://sreesilks.com',
  siteName: 'Sree Silks',
  defaultTitle: 'Sree Silks - Exquisite Silk Sarees & Wedding Collections',
  titleTemplate: '%s | Sree Silks',
  defaultDescription:
    'Discover exquisite silk sarees and wedding collections at Sree Silks. Traditional elegance meets contemporary design with bespoke gifting experiences.',
  defaultImage: 'https://sreesilks.com/assets/home-hero-bg.jpg',
  locale: 'en-IN',
  brandColor: '#17214b',
  sameAs: ['https://www.instagram.com/sssreesilks', 'https://www.facebook.com/sssreesilks'],
  contact: {
    telephone: '+91 88704 35979',
    email: 'info@sreesilks.com',
  },
  address: {
    streetAddress: 'Palanivel Chetty Street',
    addressLocality: 'Jalakandapuram',
    addressRegion: 'Tamil Nadu',
    postalCode: '636501',
    addressCountry: 'IN',
  },
  preloadAssets: [
    { href: '/assets/optimized/home-hero-bg.webp', as: 'image', type: 'image/webp', fetchPriority: 'high' },
    { href: '/assets/optimized/primary-logo-header.webp', as: 'image', type: 'image/webp' },
  ],
} satisfies SiteContent;
